module.exports = __webpack_public_path__ + "img/arrow-down.fffa3ddf.svg";